"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridItem = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const ForwardRefHOC_1 = __importDefault(require("../ForwardRefHOC"));
const utils_1 = require("../utils");
const GridItem = (_a) => {
    var { className, forwardedRef, gridArea, gridColumn, gridColumnEnd, gridColumnStart, gridRow, gridRowEnd, gridRowStart, style } = _a, restProps = __rest(_a, ["className", "forwardedRef", "gridArea", "gridColumn", "gridColumnEnd", "gridColumnStart", "gridRow", "gridRowEnd", "gridRowStart", "style"]);
    const finalClassName = classnames_1.default('bds-c-grid-item', className);
    const finalStyle = utils_1.compact(Object.assign({ gridArea,
        gridColumn,
        gridColumnEnd,
        gridColumnStart,
        gridRow,
        gridRowEnd,
        gridRowStart }, style));
    return (react_1.default.createElement("div", Object.assign({ className: finalClassName, ref: forwardedRef, style: finalStyle }, restProps)));
};
exports.GridItem = GridItem;
exports.GridItem.displayName = 'GridItem';
exports.default = ForwardRefHOC_1.default(exports.GridItem);
